import { addApiPrefix } from 'as-ui-kit/utils/urls';
import { handleResult } from 'as-ui-kit/utils/http';
import { catchWithMsg } from 'utils/http';

export const getCarTypes = (apiUrl) =>
    fetch(addApiPrefix('/carTypesStringified.json', apiUrl))
        .then(handleResult)
        .catch(catchWithMsg);
